var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"7","y":"7","width":"10","height":"10","rx":"2","fill":"var(--v-error-base)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }